import {
  AccordionDetails,
  AccordionSummary,
  styled,
  Typography,
} from "@mui/material";

export const StyledPanel = {
  IconLeftAccordionSummary: styled(AccordionSummary)(({ theme }) => ({
    "& .MuiAccordionSummary-expandIconWrapper": {
      order: -1,
      marginLeft: -20,
      marginRight: 5,
    },
  })),

  HeadingTypography: styled(Typography)(({ theme }) => ({
    fontFamily: "Roboto, sans-serif",
    fontSize: theme.typography.pxToRem(15),
  })),

  SecondaryHeadingTypography: styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  })),

  PanelDetailContainer: styled(AccordionDetails)({
    display: "flex",
    justifyContent: "center",
  }),
};
